<template>
<div>
  <div class="box">
    <p>{{ $t('msg.createUserMsg01') }}</p>
    <p>{{ $t('msg.createUserMsg02') }}</p>
  </div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.box{
  max-width: 600px;
  p{
    text-align: left;
  }
}
</style>
